module.exports = __webpack_public_path__ + "media/images/cicc-8ab286c08b880a280a36e311174caa9c.png";